import FieldType from '../../components/Form/Fields/type'
import { currencyRequired } from '@polvo-labs/form-utils'
import { currencyFormat } from '../../utils/form-validations'

export interface ProposalFormData {
  value: number
}

export type ProposalForm = keyof ProposalFormData

const fields: FieldType<ProposalForm>[] = [
  {
    name: 'value',
    data: {},
    html: {},
    size: 14,
    validation: {
      parse: (value: any) => {
        const stringValue = value.toString()
        if(value && stringValue.length <= 20)
          return currencyFormat(value)
        else
          return stringValue.slice(0, -1)
      },
      validate: (value: string, values: any) => {
        if(value && parseFloat(value) === 0)
          return 'O campo deve ser maior que 0'
        return currencyRequired.validate(value, values)
      },
    },
  },
]

export default fields
